import React, { useState, useEffect } from "react";
import "./noticeboard.css";
import PageHeader from "../about/PageHeader";

import Navbar from "../components/navbar";
import Footer from "../components/Footer";

const NoticeBoard = () => {
  const [activeTab, setActiveTab] = useState("Notices");
  const [filters, setFilters] = useState({
    semester: null,
    examType: null,
    monthYear: null,
  });
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;
  const defaultFilters = {
    semester: null,
    examType: null,
    monthYear: null,
  };

  // Fully populated data from your provided list
const allData = {
Notices: [
    { id: 40, name: "Notice Regrading Eligibility", semester: "General", category: "General", year: "2026", pdf: "/pdf/Notices/Notice Regrading Eligibility.pdf" },
    { id: 39, name: "batch 2026 marathi name for Degree certificate", semester: "General", category: "General", year: "2026", pdf: "/pdf/Notices/batch 2026 marathi name for Degree certificate.pdf" },
    { id: 38, name: "Sem 4 Supplementary Exam Notice", semester: "Sem IV", category: "Exam", year: "", pdf: "/pdf/Notices/Sem 4 Supplementary exam notice (1).pdf" },
    { id: 37, name: "Research Prj Reporting MCA Sem3", semester: "Sem III", category: "General", year: "", pdf: "/pdf/Notices/Research-Pr-Reporting-MCA-Sem3.pdf" },
    { id: 32, name: "Revision in Examination Fee", semester: "General", category: "Fees", year: "", pdf: "/pdf/Notices/Revision in Examination Fee.pdf" },
    { id: 33, name: "University of Mumbai – MCA 3 year course to 2 year course Ammendment Notice", semester: "General", category: "General", year: "", pdf: "/pdf/Notices/University of Mumbai – MCA 3 year course to 2 year course Ammendment Notice.pdf" },
    { id: 34, name: "CGPI to percentage conversion", semester: "General", category: "General", year: "", pdf: "/pdf/Notices/CGPI to percentage conversion.pdf" },
    { id: 35, name: "MCA Manual on CBCGS", semester: "General", category: "Manual", year: "", pdf: "/pdf/Notices/MCA Manual on CBCGS.pdf" },
    { id: 36, name: "Manual on grading system", semester: "General", category: "Manual", year: "", pdf: "/pdf/Notices/Manual on grading system.pdf" }
  ],
  Toppers: []
};
  const filteredData = allData[activeTab].filter((item) => {
    const matchesSemester = !filters.semester || item.semester === filters.semester;
    const matchesExamType = !filters.examType || item.category === filters.examType;
    const matchesMonthYear = !filters.monthYear || (item.year && item.year.includes(filters.monthYear));
    return matchesSemester && matchesExamType && matchesMonthYear;
  });

  useEffect(() => { setCurrentPage(1); }, [activeTab, filters]);

  // Handle pagination values correctly
  const totalPages = Math.max(1, Math.ceil(filteredData.length / itemsPerPage));
  const currentData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const handleQuickFilter = (type, val) => {
    setFilters(prev => ({ ...prev, [type]: prev[type] === val ? null : val }));
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setFilters(defaultFilters);
  };

  const getBadgeClass = (semester) => {
    if (semester.includes("III") || semester.includes("IV")) return "tims-nb-badge tims-nb-badge-green";
    if (semester.includes("I") || semester.includes("II")) return "tims-nb-badge tims-nb-badge-yellow";
    if (semester === "All" || semester === "General") return "tims-nb-badge tims-nb-badge-pink";
    return "tims-nb-badge tims-nb-badge-default";
  };

  // Helper to generate an array of page numbers to render
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <>
       <Navbar />
      <div className="tims-nb-page-root">
        <PageHeader
          title="Notice Board "
          crumbs={[
            { label: "Home", href: "/" },
            { label: "Result Analysis" },
          ]}
        />
        <div className="tims-nb-container">
          <div className="tims-nb-content-wrapper">
            
            {/* Tabs */}
            <div className="tims-nb-tabs">
              <div
                className="tims-nb-tab-indicator"
                style={{
                  transform:
                    activeTab === "Notices"
                      ? "translateX(0%)"
                      : "translateX(100%)",
                }}
              />
              <button
                className={`tims-nb-tab ${activeTab === "Notices" ? "active" : ""}`}
                onClick={() => handleTabChange("Notices")}
              >
                General Notices
              </button>
              <button
                className={`tims-nb-tab ${activeTab === "Toppers" ? "active" : ""}`}
                onClick={() => handleTabChange("Toppers")}
              >
                Topper Lists
              </button>
            </div>

            {/* Quick Filters */}
            {/* {activeTab === "Notices" && (
              <div className="tims-nb-filters">
                <button 
                  className={`tims-nb-filter-chip ${filters.examType === "KT" ? "active" : ""}`} 
                  onClick={() => handleQuickFilter("examType", "KT")}
                >
                  KT Exams
                </button>
                <button 
                  className={`tims-nb-filter-chip ${filters.examType === "Revaluation" ? "active" : ""}`} 
                  onClick={() => handleQuickFilter("examType", "Revaluation")}
                >
                  Revaluation
                </button>
                <button 
                  className={`tims-nb-filter-chip ${filters.semester === "Sem III" ? "active" : ""}`} 
                  onClick={() => handleQuickFilter("semester", "Sem III")}
                >
                  Sem III
                </button>
                <button 
                  className={`tims-nb-filter-chip ${filters.monthYear === "2025" ? "active" : ""}`} 
                  onClick={() => handleQuickFilter("monthYear", "2025")}
                >
                  2025
                </button>
                <button 
                  className={`tims-nb-filter-chip ${filters.monthYear === "2024" ? "active" : ""}`} 
                  onClick={() => handleQuickFilter("monthYear", "2024")}
                >
                  2024
                </button>
              </div>
            )} */}

            {/* {activeTab === "Toppers" && (
              <div className="tims-nb-filters">
                <button
                  className={`tims-nb-filter-chip ${filters.monthYear === "2025" ? "active" : ""}`}
                  onClick={() => handleQuickFilter("monthYear", "2025")}
                >
                  2025
                </button>
                <button
                  className={`tims-nb-filter-chip ${filters.monthYear === "2024" ? "active" : ""}`}
                  onClick={() => handleQuickFilter("monthYear", "2024")}
                >
                  2024
                </button>
                <button
                  className={`tims-nb-filter-chip ${filters.monthYear === "2023" ? "active" : ""}`}
                  onClick={() => handleQuickFilter("monthYear", "2023")}
                >
                  2023
                </button>
                <button
                  className={`tims-nb-filter-chip ${filters.monthYear === "2022" ? "active" : ""}`}
                  onClick={() => handleQuickFilter("monthYear", "2022")}
                >
                  2022
                </button>
              </div>
            )} */}

            {/* Table */}
            <div className="tims-nb-table-container">
              <table className="tims-nb-table">
                <thead>
                  <tr>
                    <th>Document Name</th>
                    <th>Semester</th>
                    <th>Category</th>
                    <th>Year</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.length > 0 ? (
                    currentData.map((item) => (
                      <tr key={item.id}>
                        <td>
                          <div className="tims-nb-doc-cell">
                            <svg className="tims-nb-doc-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                              <polyline points="14 2 14 8 20 8"></polyline>
                              <line x1="16" y1="13" x2="8" y2="13"></line>
                              <line x1="16" y1="17" x2="8" y2="17"></line>
                              <polyline points="10 9 9 9 8 9"></polyline>
                            </svg>
                            <span className="tims-nb-doc-name">{item.name}</span>
                          </div>
                        </td>
                        <td>
                          <span className={getBadgeClass(item.semester)}>
                            {item.semester}
                          </span>
                        </td>
                        <td className="tims-nb-text-dark">{item.category}</td>
                        <td className="tims-nb-text-dark">{item.year || "-"}</td>
                        <td>
                          <button className="tims-nb-view-btn" onClick={() => window.open(item.pdf)}>
                            View
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" style={{ textAlign: "center", padding: "30px", color: "#64748B" }}>
                        No notices found matching your filters.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="tims-nb-pagination">
                <button 
                  className="tims-nb-page-nav" 
                  disabled={currentPage === 1} 
                  onClick={() => setCurrentPage(p => p - 1)}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
                
                {pageNumbers.map(num => (
                  <button 
                    key={num}
                    className={`tims-nb-page-num ${currentPage === num ? "active" : ""}`}
                    onClick={() => setCurrentPage(num)}
                  >
                    {num}
                  </button>
                ))}

                <button 
                  className="tims-nb-page-nav" 
                  disabled={currentPage === totalPages} 
                  onClick={() => setCurrentPage(p => p + 1)}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
            )}

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NoticeBoard;